
import logo from "./assets/images/cc-logo.png";
import Actions from "./components/Actions";
import Assets from "./components/Assets";

import BottomNav from "./components/BottomNav";
import PaymentFAB from "./components/PaymentFAB";
import Profile from "./components/Profile";

import { WagmiConfig, createClient } from 'wagmi'
import { getDefaultProvider } from 'ethers'

const client = createClient({
  autoConnect: true,
  provider: getDefaultProvider(),
})

function App() {
  return (
    <div className="App bg-[#1A1B1B] h-[100vh] text-left text-white">
      <div className="logo containerx ">
        <img src={logo} className="py-7 w-48" alt="" />

              <div className="pfolio-worth">
        <p className="text-[#6c6c6c] mb-2">your portfolio worth (in usd)</p>
        <h2 className="text-4xl">$24,999</h2>
      </div>

              </div>

   <WagmiConfig client={client}>
      <Profile />
    </WagmiConfig>
      <Actions />
      <Assets />

      <PaymentFAB />
      <BottomNav />
    </div>
  );
}

export default App;
